const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5M21 12a9 9 0 0 1-14.812 6.872L18.872 6.188A8.96 8.96 0 0 1 21 12m-3.188-6.872A9 9 0 0 0 5.128 17.812z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
